import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';

@Component({
    standalone: false,
    selector: 'app-input-search',
    templateUrl: './input-search.component.html',
    styleUrls: ['./input-search.component.scss'],
})
export class InputSearchComponent implements OnInit {
    @Input() placeholder = '';
    @Input() hideSearch = true;
    @Input() loading = false;
    @Input() size: 'default' | 'small' = 'default';
    @Output() onSearch = new EventEmitter<string>();
    @Output() onWriteSearch = new EventEmitter<string>();
    @Output() onHideSearch = new EventEmitter<void>();
    @Output() onClickInputSearch = new EventEmitter<void>();

    @ViewChild('flwSearchElem') flwSearchElem: ElementRef<HTMLFlwSearchElement>;

    searchTextChanged: Subject<string> = new Subject<string>();
    searchText = '';
    isSearching = false;

    constructor() {}

    ngOnInit(): void {
        this.searchTextChanged
            .pipe(
                tap(() => (this.isSearching = true)),
                debounceTime(200),
                tap(() => (this.isSearching = false)),
                distinctUntilChanged()
            )
            .subscribe((text) => this.onWriteSearch.emit(text));
    }

    clickHideSearchButton(): void {
        this.searchText = '';
        this.onHideSearch.emit();
    }

    clickInputSearch(): void {
        this.onClickInputSearch.emit();
    }

    inputSearch(text: string): void {
        this.searchText = text;
        this.searchTextChanged.next(text);
    }

    /** Limpia y corta el loading en curso */
    clearSearch(): void {
        this.searchText = '';
        this.isSearching = false;
        this.onWriteSearch.emit('');
    }

    enterKeyPressed(): void {
        this.hideKeyboard();
        this.onSearch.emit(this.searchText);
    }

    hideKeyboard(): void {
        if (Capacitor.isNativePlatform()) {
            Keyboard.hide();
        }
    }

    clearInput() {
        this.searchText = '';
        this.isSearching = false;
    }

    setFocus(): void {
        this.flwSearchElem?.nativeElement.setFocus();
    }
}
